import { TRANSLIT, EN_REGEX, RU_REGEX } from '../constants/string.js';
import { isArray } from './array.js';

function isString(value) {
  return typeof value === 'string';
}
function isValidString(string) {
  return isString(string) && !isArray(string) && string.length !== 0;
}
function capitalize(string) {
  if (!isValidString(string)) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
function plural(count, wordFormsArray) {
  const roundedCount = Math.round(count);
  let wordIndex;
  if (roundedCount % 10 === 1 && roundedCount % 100 !== 11) {
    wordIndex = 0; // one
  } else if (roundedCount % 10 >= 2 && roundedCount % 10 <= 4 && (roundedCount % 100 < 10 || roundedCount % 100 >= 20)) {
    wordIndex = 1; // few
  } else {
    wordIndex = 2; // many
  }
  return wordFormsArray[wordIndex] || '';
}
function convertString(value, lang = 'ru') {
  if (!isString(value)) return '';
  const lettersArray = value.split('');
  return lettersArray.reduce((acc, char) => {
    var _a;
    return acc + (((_a = TRANSLIT[lang]) === null || _a === void 0 ? void 0 : _a[char]) || char);
  }, '');
}
function convertToTranslit(value) {
  const initial = String(value);
  if (EN_REGEX.test(value)) return convertString(value, 'en');
  if (RU_REGEX.test(value)) return convertString(value, 'ru');
  return initial;
}
function toCamelCase(str, options = {}) {
  if (!isString(str) && !isArray(str)) return str;
  if (isArray(str)) return toCamelCase(str.join(' '), options);
  const result = str.trim().replace(/[^\p{L}\p{N}]+(\p{L})/gu, (_, char) => char.toUpperCase());
  return options.pascalCase ? result.charAt(0).toUpperCase() + result.slice(1) : result.charAt(0).toLowerCase() + result.slice(1);
}
function toBase64(str) {
  try {
    return btoa(str);
  } catch (err) {
    return Buffer.from(str, 'binary').toString('base64');
  }
}
function fromBase64(b64Encoded) {
  try {
    return atob(b64Encoded);
  } catch (err) {
    return Buffer.from(b64Encoded, 'base64').toString('binary');
  }
}

export { capitalize, convertString, convertToTranslit, fromBase64, isString, isValidString, plural, toBase64, toCamelCase };
